import { withNamespaces } from "react-i18next";
import { memo, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { withRouter } from "react-router-dom";

// components
import PageBody from "../../../../components/page-body";
import Navigator from "src/components/Navigator";
import PageContent from "../../../../components/page-content";
import HardwareDetailsTabs from "./components/hardware-details-tabs";

import DataProtectionHardwareInformation from "../../hardware/details/information";
// styles
import "./style.scss";

const DataProtectionHardwareDetails = (props) => {
  const [assetHeaderData, setAssetHeaderData] = useState({
    name: "...",
    assetId: null,
  });
  const {t} = props;
  const {path, params} = useRouteMatch();
  const { hardwareId } = params;

  const pageTitle = assetHeaderData?.name
    ? `${assetHeaderData.name}${assetHeaderData?.assetId ? `-ID: ${assetHeaderData.assetId}` : ""}`
    : "...";

  return (
    <PageContent classNames="data-protection-hardware-details-page">
      <Container fluid>
        {/* page header */}
        <Row>
          <Col lg="12" className="mb-4">
            <Navigator
              pageTitle={pageTitle}
              translate={false}
              breadCrumbs={[
                {
                  title: t("SIP"),
                  link: "/admin/data-protection/dashboard",
                },
                {
                  title: t("Hardware Assets"),
                  link: "/admin/data-protection/hardwares",
                },
                {
                  title: assetHeaderData?.name || "...",
                  link: `/admin/data-protection/hardwares/${hardwareId}`,
                },
                {
                  title: t("Detail"),
                  link: "#",
                },
              ]}
              backButtonOptions={(defaults) => ({
                ...defaults,
                enable: true,
                title: t("Back"),
              })}
            />
          </Col>
        </Row>

        {/* page body */}
        <PageBody classNames="p-4">
          <HardwareDetailsTabs t={t}/>

            <Switch>
                <Route exact path={path}>
                    <DataProtectionHardwareInformation setAssetHeaderData={setAssetHeaderData} />
                </Route>
            </Switch>
        </PageBody>
      </Container>
    </PageContent>
  );
};

export default withNamespaces()(
  withRouter(memo(DataProtectionHardwareDetails))
);
